// test2148
(2148 && 0);
